import React, { useState, useEffect } from "react";

//user import

import { Route, Routes, useLocation } from "react-router-dom";
import {
	Toolbar,
	Box,
	Grid,
	Snackbar,
	Alert,
	CircularProgress,
	Backdrop,
	useTheme,
} from "@mui/material";

//user import

import { Sidebar } from "./components";
import {
	PrivateRoute,
	PrivateRouteWrapper,
} from "../../Services/Routes/APP/PrivateRoute";
import { provinceAdminRoutes } from "../../pages/ProvinceAdminPortal/routes";

import CableConsumer from "../../Services/CableConnection";
import Dashboard from "../../pages/ProvinceAdminPortal/Dashboard";
import CustomAppBar from "../../components/CustomAppBar";

//components

function AdminPortal() {
	const location = useLocation();
	let navigationsArray = location?.pathname?.split("/") || [];
	navigationsArray?.reverse().pop();
	const urlNavPoints = navigationsArray;
	const urlEndingPoint = urlNavPoints[0];
	urlNavPoints?.reverse();
	const urlStartPoint = navigationsArray[0];

	const THEME = useTheme();
	const CONTENT_PAGE_EL = document.getElementById("content-page");
	//states

	const [mobileOpen, setMobileOpen] = useState(false);
	const [backdropOpen, setBackdropOpen] = useState(false);
	const [showCustomAppBar, setShowCustomAppBar] = useState(false);
	const [showMobileSideBar, setShowMobileSideBar] = useState(false);
	const [newNotification, setNewNotification] = useState(null);
	const [cableConnectionStatus, setCableConnectionStatus] = useState({
		initializing: true,
		connected: false,
		disconnected: false,
		receivingData: false,
	});
	const [contentPageMinHeight, setContentPageMinHeight] = useState(0);

	const handleNotificationConnectionSuccess = () => {
		setCableConnectionStatus({
			...cableConnectionStatus,
			initializing: false,
			connected: true,
			disconnected: false,
		});
	};
	const handleNotificationReceived = (data) => {
		setCableConnectionStatus({
			...cableConnectionStatus,
			receivingData: true,
		});
		setNewNotification(data);
		setCableConnectionStatus({
			...cableConnectionStatus,
			receivingData: false,
		});
	};
	const handleConnectionDisconnect = () => {
		setCableConnectionStatus({
			...cableConnectionStatus,
			initializing: true,
			connected: false,
			disconnected: true,
		});
	};

	const clearNewNotification = (notificationToClear) => {
		if (newNotification && newNotification === notificationToClear) {
			setNewNotification(null);
		}
	};

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	//functions

	useEffect(() => {
		if (urlNavPoints?.length === 2) {
			setShowCustomAppBar(true);
		} else {
			setShowCustomAppBar(false);
		}
		if (urlEndingPoint === "nodeView") {
			setShowMobileSideBar(true);
		} else {
			showMobileSideBar && setShowMobileSideBar(false);
		}
	}, [urlNavPoints]);

	useEffect(() => {
		if (!cableConnectionStatus?.connected) {
			setBackdropOpen(true);
		} else if (backdropOpen) {
			setBackdropOpen(false);
		}
	}, [cableConnectionStatus]);

	useEffect(() => {
		setContentPageMinHeight(
			window.innerHeight - (CONTENT_PAGE_EL?.previousSibling?.offsetHeight || 0)
		);
	}, [CONTENT_PAGE_EL]);

	//render

	return (
		<Box
			sx={{
				display: "flex",
				minHeight: "inherit",
				// minBlockSize: "inherit"
			}}
		>
			<Sidebar
				handleDrawerToggle={handleDrawerToggle}
				mobileOpen={mobileOpen}
				showMobileSideBar={showMobileSideBar}
			/>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					width: {
						md: "calc(100% - 20rem)",
						sm: "100%",
						xs: "100%",
					},
				}}
			>
				<CableConsumer
					channelName={"NotificationChannel"}
					handleDataReceived={handleNotificationReceived}
					handleChannelConnected={handleNotificationConnectionSuccess}
					handleConnectionDisconnect={handleConnectionDisconnect}
				/>
				<CustomAppBar
					handleDrawerToggle={handleDrawerToggle}
					cableConnectionStatus={cableConnectionStatus}
					newNotification={newNotification}
					clearNewNotification={clearNewNotification}
					show={showCustomAppBar}
					sideBarMenuShow={showMobileSideBar}
				/>
				{/* <Toolbar /> */}
				<Grid
					id={"content-page"}
					container
					padding={{ xs: 1, sm: 1, md: 3 }}
					paddingTop={
						showCustomAppBar ? "0px !important" : { xs: 1, sm: 1, md: 3 }
					}
					sx={{
						minHeight: `${contentPageMinHeight}px`,
					}}
				>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<Routes>
							{provinceAdminRoutes?.map((item, index) => (
								<Route
									key={`${index}-admin-routes-${item?.path}`}
									//   caseSensitive={item?.exact}
									path={item?.path}
									element={
										item?.path === "/dashboard" || item?.path === "/" ? (
											<PrivateRouteWrapper>
												<Dashboard />
											</PrivateRouteWrapper>
										) : (
											<PrivateRoute element={item.component} />
										)
									}
								/>
							))}
						</Routes>

						<Backdrop
							sx={{
								zIndex: THEME.zIndex.drawer + 1,
								color: THEME.palette.primary.main,
							}}
							open={backdropOpen}
						>
							<CircularProgress color="inherit" />
						</Backdrop>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}

export default AdminPortal;
